const getLocalStorage = (): Storage | null => {
  if (typeof window === "undefined") return null;
  return window.localStorage ?? null;
};

export const readStorageItem = (key: string): string | null => {
  const storage = getLocalStorage();
  if (!storage) return null;

  try {
    return storage.getItem(key);
  } catch (error) {
    console.warn(`Could not read localStorage key "${key}"`, { error });
    return null;
  }
};

export const writeStorageItem = (key: string, value: string): boolean => {
  const storage = getLocalStorage();
  if (!storage) return false;

  try {
    storage.setItem(key, value);
    return true;
  } catch (error) {
    console.warn(`Could not write localStorage key "${key}"`, { error });
    return false;
  }
};

export const removeStorageItem = (key: string): void => {
  const storage = getLocalStorage();
  if (!storage) return;

  try {
    storage.removeItem(key);
  } catch (error) {
    console.warn(`Could not remove localStorage key "${key}"`, { error });
  }
};
